export const common = {
  // Navbar
  courseFlow: 'コースの流れ',
  curriculum: 'カリキュラム',
  pricing: '料金プラン',
  wordPool: '単語プール',
  levelCheck: 'レベルチェック',
  register: '登録する',
  myPage: 'マイページ',
  signOut: 'ログアウト',
  admin: '管理画面',
  orgSchedule: '団体スケジュール',
  
  // Footer
  quickLinks: 'クイックリンク',
  home: 'ホーム',
  contact: 'お問い合わせ',
  contactForm: 'お問い合わせフォーム',
  allRightsReserved: 'All rights reserved.',
  websiteBuilder: 'Website Builder',
  
  // Common
  submit: '送信',
  submitting: '送信中...',
  required: '必須項目',
  optional: '任意',
  cancel: 'キャンセル',
  close: '閉じる',
  save: '保存',
  delete: '削除',
  edit: '編集',
  add: '追加',
  search: '検索',
  filter: 'フィルター',
  loading: '読み込み中...',
  error: 'エラーが発生しました',
  success: '成功しました',
  
  // Brand
  brandName: 'EachTeach',
  brandTagline: '真剣な学習者のための高品質な1対1言語交換サービス',
  additionalLesson: {
    title: '追加レッスン申し込み',
    subtitle: '興味のある分野の専門レッスンに申し込む',
    backToCourseFlow: 'コースの流れに戻る',
    specializedFields: '8つの専門分野',
    chooseYourField: '分野を選択',
    fieldDescription: '各コースは特定の職場シーンとコミュニケーションニーズに合わせて設計されています',
    lessons: 'レッスン',
    courses: {
      daily: {
        name: '日常生活・カジュアルコミュニケーション',
        description: '日常会話、雑談、スラング、慣用句、ことわざなど、生活や人間関係で使われる汎用的な表現を学びます。'
      },
      customerService: {
        name: '接客・ホスピタリティコミュニケーション',
        description: 'レストランやカフェなどの接客現場で必要となる、注文対応、説明、おすすめ、クレーム対応などの表現を学びます。'
      },
      kitchen: {
        name: 'キッチン・調理コミュニケーション',
        description: 'キッチンや調理現場で使われる指示表現、食材・調理用語、安全確認、チーム内連携を学びます。'
      },
      retail: {
        name: '販売・レジ対応コミュニケーション',
        description: '小売店やショップでの接客を想定し、商品説明、サイズ・在庫確認、支払い、返品・交換対応などを学びます。'
      },
      hotel: {
        name: 'ホテル・フロント業務',
        description: 'ホテルや宿泊施設での業務を想定し、チェックイン・チェックアウト、施設案内、問い合わせ、電話対応、クレーム対応を学びます。'
      },
      cleaning: {
        name: '清掃・バックオフィス業務',
        description: '清掃やバックヤード業務で必要となる、指示理解、確認表現、チェックリスト、安全関連の表現を学びます。'
      },
      resort: {
        name: 'リゾート・季節労働',
        description: '観光地や短期雇用の職場を想定し、多国籍環境でのチーム内コミュニケーションや接客表現を学びます。'
      },
      workplace: {
        name: '職場・高度なコミュニケーション',
        description: '就労後の職場環境を想定し、Eメール、報告、調整、依頼、トラブル共有など、より高度な業務コミュニケーションを学びます。'
      }
    },
    form: {
      title: '申し込みフォーム',
      subtitle: '以下のフォームに記入して、選択した分野に申し込んでください',
      name: '名前',
      email: 'メールアドレス',
      language: '学習言語',
      firstChoice: '第一希望',
      secondChoice: '第二希望',
      thirdChoice: '第三希望',
      goals: '学習目標・リクエスト',
      required: '必須',
      optional: '任意',
      selectLanguage: '言語を選択',
      japanese: '日本語',
      korean: '韓国語',
      english: '英語',
      selectFirstChoice: '第一希望を選択',
      selectSecondChoice: '第二希望を選択（任意）',
      selectThirdChoice: '第三希望を選択（任意）',
      goalsPlaceholder: '学習目標や具体的なリクエストをご記入ください（任意）',
      characters: '文字',
      cancel: 'キャンセル',
      submit: '申し込む',
      submitting: '送信中...',
      successMessage: '申し込みが正常に送信されました。',
      errorMessage: 'すべての必須項目を入力してください。',
      submitError: '送信に失敗しました。もう一度お試しください。'
    },
    info: {
      title: '追加レッスンについて:',
      point1: 'レッスンA-C修了後に受講可能',
      point2: '興味のある分野に特化した専門レッスン',
      point3: '2-3営業日以内にご連絡いたします',
      point4: '最大3つの希望分野を選択できます'
    }
  }
};
